/* eslint-disable max-len */
export interface MeasurementDefinition {
    name?: string;
    description?: string;
    image: string;
    iso?: string;
}

export const measurementDefinitionMap: { [key: string]: MeasurementDefinition } = {
    underBust: {
        image: 'under_bust.png',
    },
    highTrouserWaistline: {
        image: 'trouser_waistline_female.png',
    },
    trouserWaistline: {
        image: 'trouser_waistline.png',
    },
    rightTibia: {
        image: 'tibia_length.png',
    },
    leftTibia: {
        image: 'tibia_length.png',
    },
    leftThigh: {
        image: 'thigh.png',
    },
    rightThigh: {
        image: 'thigh.png',
    },
    height: {
        image: 'height.png',
    },
    rightPantInseam: {
        image: 'pant_inseam.png',
    },
    leftPantInseam: {
        image: 'pant_inseam.png',
    },
    rightHighOutleg: {
        image: 'high_trouser_outleg_female.png',
    },
    leftHighOutleg: {
        image: 'high_trouser_outleg_female.png',
    },
    rightOutleg: {
        image: 'outleg.png',
    },
    leftOutleg: {
        image: 'outleg.png',
    },
    neck: {
        image: 'neck.png',
    },
    navelGirth: {
        image: 'navel_girth.png',
    },
    frontNeckToWaist: {
        image: 'front_neck_to_waist.png',
        iso: '5.4.8 Front neck point to waist',
    },
    narrowWaist: {
        image: 'narrow_waist.png',
    },
    hip: {
        image: 'hip.png',
    },
    head: {
        image: 'head_girth.png',
    },
    rightForearm: {
        image: 'forearm.png',
    },
    leftForearm: {
        image: 'forearm.png',
    },
    leftCalf: {
        image: 'calf.png',
    },
    rightCalf: {
        image: 'calf.png',
    },
    bust: {
        image: 'bust.png',
    },
    bustPointWidth: {
        image: 'bust_point_width.png',
        iso: '5.2.3 Bust point width',
    },
    rightLowerKnee: {
        image: 'lower_knee.png',
        iso: '5.3.23 Lower knee girth',
    },
    leftLowerKnee: {
        image: 'lower_knee.png',
        iso: '5.3.23 Lower knee girth',
    },
    acrossBackWidth: {
        image: 'across_back_width.png',
        iso: '5.4.4 Across back width',
    },
    acrossFrontWidth: {
        image: 'across_front_width.png',
        iso: '5.4.7 Across front width',
    },
    backNeckToRightKnee: {
        image: 'back_neck_to_knee.png',
    },
    backNeckToLeftKnee: {
        image: 'back_neck_to_knee.png',
    },
    frontShoulderWidth: {
        image: 'front_shoulder_width.png',
    },
    leftBiceps: {
        image: 'biceps.png',
    },
    rightBiceps: {
        image: 'biceps.png',
    },
    backNeckToWaist: {
        image: 'back_neck_to_waist.png',
    },
    backShoulderWidth: {
        image: 'back_shoulder_width.png',
    },
    bellyOutleg: {
        image: 'belly_outleg.png',
    },
    longestNeckToWrist: {
        image: 'back_neck_to_wrist.png',
    },
    narrowWaistToGround: {
        image: 'narrow_waistline_to_ground.png',
    },
    handLength: {
        image: 'hand_length.png',
    },
    handWidth: {
        image: 'hand_width.png',
    },
    handWidthAcrossThumb: {
        image: 'hand_width_across_thumb.png',
    },
    shoulder: {
        image: 'shoulder.png',
    },
    backNeckToHip: {
        image: 'back_neck_point_to_hip.png',
    },
    highTrouserWaistlineToGround: {
        image: 'high_trouser_waistline_to_ground_female.png',
    },
    trouserWaistlineToGround: {
        image: 'trouser_waistline_to_ground_male.png',
    },
    longestFootLength: {
        image: 'longest_foot_length.png',
    },
    widestFootWidth: {
        image: 'widest_foot_width.png',
    },
    leftFootLength: {
        image: 'foot_length_left.png',
    },
    leftFootWidth: {
        image: 'foot_width_left.png',
    },
    leftFootTreadWidth: {
        image: 'foot_tread_width_left.png',
    },
    rightFootLength: {
        image: 'foot_length_right.png',
    },
    rightFootWidth: {
        image: 'foot_width_right.png',
    },
    rightFootTreadWidth: {
        image: 'foot_tread_width_right.png',
    },
    handFingerLength: {
        image: 'hand_finger_length.png',
    },
    backNeckToGround: {
        image: 'back_neck_to_ground.png',
        iso: '5.1.5 Back neck height',
    },
    topHip: {
        image: 'top_hip.png',
        iso: '5.3.12 Top hip girth',
    },
    maximumHip: {
        image: 'maximum_hip.png',
    },
    minimumLegGirth: {
        image: 'minimum_leg_girth.png',
        iso: '5.3.25 Minimum leg girth',
    },
    neckBase: {
        image: 'neck_base.png',
        iso: '5.3.3 Neck base girth',
    },
    orbitaleToGround: {
        image: 'orbitale_to_ground.png',
        iso: '3.1.4 Orbitale',
    },
    outerArmLength: {
        image: 'outer_arm_length.png',
        iso: '5.4.14 and 5.4.15 Upper\\Lower arm length',
    },
    shoulderLength: {
        image: 'shoulder_length.png',
        iso: '5.4.1 Shoulder length',
    },
    shoulderToBust: {
        image: 'shoulder_to_bust.png',
        iso: '5.4.10 Side neck point to bust point',
    },
    shoulderToWaist: {
        image: 'shoulder_to_waist.png',
    },
    waistToTopHip: {
        image: 'waist_to_top_hip.png',
    },
    waistToKnee: {
        image: 'waist_to_knee.png',
    },
    waistToMaximumHip: {
        image: 'waist_to_maximum_hip.png',
    },
    leftWrist: {
        image: 'wrist.png',
        iso: '5.3.19 Wrist girth',
    },
    rightWrist: {
        image: 'wrist.png',
        iso: '5.3.19 Wrist girth',
    },
    leftFootJointGirth: {
        image: 'foot_joint_girth_left.png',
        iso: 'ISO 19408 - 2.1.8 Joint girth of the foot',
    },
    rightFootJointGirth: {
        image: 'foot_joint_girth_right.png',
        iso: 'ISO 19408 - 2.1.8 Joint girth of the foot',
    },
    frontNeckToNavel: {
        image: 'front_neck_to_navel.png',
    },
    volume: {
        image: 'volume.png',
    },
    leftUpperArm: {
        image: 'upper_arm.png',
    },
    rightUpperArm: {
        image: 'upper_arm.png',
    },
    leftSideNeckToElbow: {
        image: 'side_neck_to_elbow.png',
    },
    rightSideNeckToElbow: {
        image: 'side_neck_to_elbow.png',
    },
    leftSideNeckToWrist: {
        image: 'side_neck_to_wrist.png',
    },
    rightSideNeckToWrist: {
        image: 'side_neck_to_wrist.png',
    },
    backNeckToKneeHeight: {
        image: 'back_neck_to_knee_height.png',
    },
    highTrouserWaistlineToKneeHeight: {
        image: 'high_trouser_waistline_to_knee_height.png',
    },
    trouserWaistlineToKneeHeight: {
        image: 'trouser_waistline_to_knee_height.png',
    },
};
